import { render, staticRenderFns } from "./BaseAlertMessage.vue?vue&type=template&id=1fb3259d&"
import script from "./BaseAlertMessage.vue?vue&type=script&lang=js&"
export * from "./BaseAlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./BaseAlertMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports